import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { TranslationKey } from '../../translations/default'
import { NavigationBlockModalType, Page } from '../../utils/enums'

export interface NavigationState {
  canLeave: NavigationLeaveFn | undefined
  navState: Partial<NavState>
  navType: NavigationBlockType | undefined
}

export const initialNavigationState: NavigationState = {
  canLeave: undefined,
  navState: {},
  navType: undefined,
}

export interface NavState extends Record<Page, object | string> {
  [Page.UserEdit]: {
    editType: 'create' | 'edit'
    isDirty: boolean
    userType: 'internal' | 'external'
  }
  [Page.OrderDetails]: {
    editType: 'view' | 'edit'
    isDirty: boolean
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type NavAction<T extends Page = any> = {
  navState: NavState[Page]
  page: T
}

type NavigationLeaveFn = (isAllowedToLeave: boolean) => void

export type NavigationBlockType = {
  message?: TranslationKey
  type: NavigationBlockModalType
}

export const navigationSlice = createSlice({
  initialState: initialNavigationState,
  name: 'navigation',
  reducers: {
    clearNavigationStateAction(state: NavigationState) {
      state.navState = {}
    },

    hideBlockNavigationModalAction(state: NavigationState) {
      delete state.canLeave, delete state.navType
    },

    setNavigationStateAction(
      state,
      { payload: { navState, page } }: PayloadAction<NavAction<Page>>,
    ) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      ;(state.navState as any)[page] = navState
    },

    showBlockNavigationModalAction: (
      state: NavigationState,
      {
        payload,
      }: PayloadAction<{
        canLeave: NavigationLeaveFn
        navType: NavigationBlockType
      }>,
    ) => ({
      ...state,
      ...payload,
    }),
  },
})

export default navigationSlice.reducer
